import { InputStatesEnum } from '../../FieldControlled/common.js';
import { FieldValid } from './types.js';

function mergeValidations(m1, m2) {
    if (!m1)
        return m2;
    if (!m2)
        return m1;
    if (m1.includes(m2))
        return m1;
    if (m2.includes(m1))
        return m2;
    return [m1, m2].join(', ');
}
function mergeValidationStates(...validations) {
    return validations.reduce((validation, current = FieldValid) => {
        if (validation.state === current.state) {
            return { state: current.state, stateMessage: mergeValidations(validation.stateMessage, current.stateMessage) };
        }
        const errorLevels = [
            InputStatesEnum.loading,
            InputStatesEnum.alarm,
            InputStatesEnum.warning,
            InputStatesEnum.success,
        ];
        for (let i = 0; i < errorLevels.length; i++) {
            const level = errorLevels[i];
            if (validation.state === level)
                return validation;
            if (current.state === level)
                return current;
        }
        return current;
    }, {});
}
function isValidationChanged(newValidation, oldValidation) {
    if ((newValidation === null || newValidation === void 0 ? void 0 : newValidation.state) !== (oldValidation === null || oldValidation === void 0 ? void 0 : oldValidation.state))
        return true;
    if ((newValidation === null || newValidation === void 0 ? void 0 : newValidation.stateMessage) !== (oldValidation === null || oldValidation === void 0 ? void 0 : oldValidation.stateMessage))
        return true;
    return false;
}

export { isValidationChanged, mergeValidationStates };
